const collapseStyles = theme => ({
  '.ant-collapse-borderless': {
    '.ant-collapse-item': {
      borderBottomWidth: '0px',
      '&.border-dashed-bottom, &.border-solid-bottom': {
        borderWidth: '0px',
        borderStyle: 'dashed',
        borderBottomWidth: '1px',
        borderColor: theme('colors.grey.25'),
        '.ant-collapse-content': {
          color: theme('colors.black'),
          '.ant-collapse-content-box': {
            paddingLeft: '0px',
          },
        },
        '.ant-collapse-header[aria-expanded="false"]': {
          padding: '37px 0px',
        },
        '.ant-collapse-header[aria-expanded="true"]': {
          padding: '37px 0 20px 0',
        },
        '&:last-of-type': {
          borderBottom: '0px',
        },
      },
      '&.border-solid-bottom': {
        borderStyle: 'solid',
        '&.blue-panel': {
          '.ant-collapse-header': {
            padding: '8px 15px',
            backgroundColor: theme('colors.blue1.15'),
          },
        },
      },
    },
  },
});

module.exports = { collapseStyles };
